import en from "./localeEn";
import es from "./localeEs";
import pt from "./localePt";
export { en, es, pt };
export { COLLABORATOR_I18N_KEY } from "./constants";
export var locales = {
  es: es,
  pt: pt,
  en: en
};